import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useTealiumEventProperties, useTrackPageView } from '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/analytics';
import '@grandvisionhq/payments';
import { mapVisualLineItemProductToTealiumProduct, cartToTealiumPriceInfo, cartToTealiumOrderDiscountInfo, getCartSubscriptionFrequency } from '../../mappers/analytics/tealium/line-item-to-tealium-product.js';

const TealiumCartPageView = ({ children , cart , loading ,  })=>{
    const { commonEventProperties , getCommonUserProperties  } = useTealiumEventProperties();
    const handleCartEvent = React.useCallback(swcHelpers.asyncToGenerator(function*() {
        var ref;
        const commonUserProperties = yield getCommonUserProperties();
        if (!commonUserProperties) return;
        if (cart && (cart === null || cart === void 0 ? void 0 : cart.visualLineItems.length)) {
            const lineItems = cart === null || cart === void 0 ? void 0 : cart.visualLineItems;
            const Products = mapVisualLineItemProductToTealiumProduct(lineItems, true);
            const { Order_Subtotal , Order_Total , Order_ProductsAmount  } = cartToTealiumPriceInfo(cart);
            const { Order_DiscountCode , Order_DiscountName  } = cartToTealiumOrderDiscountInfo(cart);
            return Promise.resolve(swcHelpers.objectSpread({
                id: 'VirtualPage-View',
                Page_Type: 'CartPage',
                Page_Section1: 'CartPage'
            }, commonEventProperties, commonUserProperties, {
                Products,
                Order_DiscountCode,
                Order_DiscountName,
                Order_SubscriptionFrequency: getCartSubscriptionFrequency(cart),
                Order_Subtotal,
                Order_Total,
                Order_ProductsAmount
            }));
        }
        if (!loading && cart === null) {
            return Promise.resolve(swcHelpers.objectSpread({
                id: 'VirtualPage-View',
                Page_Type: 'CartPage',
                Page_Section1: 'CartPage',
                Page_Design: 'Empty'
            }, commonEventProperties, commonUserProperties));
        }
        if (!loading && !(cart === null || cart === void 0 ? void 0 : (ref = cart.lineItems) === null || ref === void 0 ? void 0 : ref.length)) {
            return Promise.resolve(swcHelpers.objectSpread({
                id: 'VirtualPage-View',
                Page_Type: 'CartPage',
                Page_Section1: 'CartPage',
                Page_Design: 'Empty'
            }, commonEventProperties, commonUserProperties));
        }
        return;
    }), [
        cart,
        commonEventProperties,
        getCommonUserProperties,
        loading
    ]);
    useTrackPageView(handleCartEvent);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, children);
};

export { TealiumCartPageView };
//# sourceMappingURL=TealiumCartPageView.js.map
